/**
 * Company Email editability for VendorOrganizationForm (manage account /
 * admin viewing a vendor).
 *
 * Editable whenever the org is being edited. Locked only when creating a
 * dual-role vendor whose email was prefilled from the linked sponsor org.
 */
export function isCompanyEmailDisabled({
  mode,
  selectedSponsorIdDual,
  providerEmail,
}) {
  return (
    mode === "create" &&
    !!selectedSponsorIdDual &&
    !!providerEmail?.length
  );
}

/**
 * Maps the form Company Email into the provider create/update payload.
 * Always included so manage-account edits persist via PATCH Providers/{id}.
 */
export function mapCompanyEmailToProviderPayload(formEmail) {
  return { email: formEmail ?? "" };
}
